import { Base_Url } from "../../BaseURL/BaseUrl";
import { getApiWithAuthorization, postApiWithAuthorization } from "../ApiMethods/ApiMethod";

const Url = `${Base_Url}`;

export const GetZoneModalList = async (requestJson) => {
  const res = await postApiWithAuthorization(
    `${Url}/Zone/GetZoneList`, requestJson
  );
  return res;
};

export const UpdateZoneStatus = async (UserKeyID, ZoneKeyID) => {
  const res = await getApiWithAuthorization(
    `${Url}/Zone/ChangeZoneStatus?UserKeyID=${UserKeyID}&ZoneKeyID=${ZoneKeyID}`
  );
  return res;
};

export const GetZoneModelData = async (UserKeyID) => {

  const res = await getApiWithAuthorization(
    `${Url}/Zone/GetZoneModel?ZoneKeyID=${UserKeyID}`
  );
  return res;
};

export const AddUpdateZoneModalData = async (requestJson) => {
  const res = await postApiWithAuthorization(
    `${Url}/Zone/AddUpdateZone`, requestJson
  );
  return res;
};


export const ZoneLookupList = async () => {
  const res = await getApiWithAuthorization(
    `${Url}/Zone/GetZoneLookupList`
  );
  return res;
};